import ManageMealPlans from './ManageMealPlans';

export default ManageMealPlans;
